import {
  Boolean_BooleanNull,
  Date_NumberNull,
  Enum_StringNull,
  Multiselect_StringArrayNull,
  Number_NumberNull,
  String_StringNull,
} from './beneficiary'

// ================================ SCHEMA ================================

export type StructuredDataSchemaDTO = StructuredDataSchema
export type UpdateStructuredDataSchemaDTO = StructuredDataSchema

// === Not really a DTO because it's stored in the database ===
export const StructuredDataTypeArray = ['string', 'number', 'date', 'boolean', 'enum', 'multiselect'] as const
export type StructuredDataType = (typeof StructuredDataTypeArray)[number]

export interface BaseSchemaItem {
  id: string
  label: string
  type: StructuredDataType
  instructionsToFillValue?: string
}

export interface StringSchemaItem extends BaseSchemaItem {
  type: 'string'
  defaultValue: String_StringNull
}

export interface NumberSchemaItem extends BaseSchemaItem {
  type: 'number'
  defaultValue: Number_NumberNull
}

export interface DateSchemaItem extends BaseSchemaItem {
  type: 'date'
  defaultValue: Date_NumberNull
}

export interface BooleanSchemaItem extends BaseSchemaItem {
  type: 'boolean'
  defaultValue: Boolean_BooleanNull
}

export interface EnumSchemaItem extends BaseSchemaItem {
  type: 'enum'
  enumValues: string[]
  defaultValue: Enum_StringNull
}

export interface MultiselectSchemaItem extends BaseSchemaItem {
  type: 'multiselect'
  enumValues: string[]
  defaultValue: Multiselect_StringArrayNull
}

export type StructuredDataSchemaItem =
  | StringSchemaItem
  | NumberSchemaItem
  | DateSchemaItem
  | BooleanSchemaItem
  | EnumSchemaItem
  | MultiselectSchemaItem

export type StructuredDataSchema = StructuredDataSchemaItem[]

// ================================ DISPLAY ================================

export type StructuredDataDisplayDTO = StructuredDataDisplay
export type UpdateStructuredDataDisplayDTO = StructuredDataDisplay

export type StructuredDataSectionDisplay = {
  id: string
  label: string
  structuredDataIds: string[]
}

export type StructuredDataDisplay = StructuredDataSectionDisplay[]

// ================================ VALUE ================================

// Raw means from LLM (can't be trusted)
export type StructuredDataRawValueDTO = {
  [key: string]: StructuredDataSchemaItem['defaultValue']
}

// Output expected by the frontend (can be trusted)
export type StructuredDataValueDTO = StructuredDataItemValueDTO[]

type StructuredDataItemValueDTO = {
  schemaItemId: StructuredDataSchemaItem['id']
  value: StructuredDataSchemaItem['defaultValue']
}

export type StructuredDataValue = {
  // NOTE: undefined is allowed
  [id: StructuredDataSchemaItem['id']]: StructuredDataSchemaItem['defaultValue']
}

// ================================ STATUS ================================

export enum StructuredDataStatus {
  _DEFAULT = '_default',
  OUTDATED = 'outDated',
  PROCESSING = 'processing',
  UPDATED = 'updated',
}

export type StructuredDataState = {
  status: StructuredDataStatus
  epoch: number
}
